export default function hateoas(links) {
  return {
    has: rel => !!links.find(link => link.rel === rel),
    get: (rel) => {
      const link = links.find(l => l.rel === rel);
      return link && link.href ? link.href : null;
    },
  };
}
